export default __webpack_public_path__ + "static/media/overwatch-ui.29a1eddd.png";